import React, { useState } from "react";
import styles from "./CreditBalance.module.css";
import { FiEdit2 } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import Dropdown from "../../components/Dropdown/Dropdown";
import SearchBar from "../../components/SearchBar/SearchBar";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import IconAndName from "../../components/IconAndName/IconAndName";
import { MdOutlineTextSnippet } from "react-icons/md";
import CopyRight from "../../components/CopyRight/CopyRight";
import { IoMdTrash } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const data = [
  {
    _id: "s1",
    studentName: "John Jacob",
    transferredFromDeposit: 4000,
    creditUsed: 2600,
    creditRefunded: 3600,
    creditBalance: 2400,
  },
  {
    _id: "s2",
    studentName: "Jane Smith",
    transferredFromDeposit: 2000,
    creditUsed: 1000,
    creditRefunded: 500,
    creditBalance: 500,
  },
];
  

const CreditBalance = () => {
  const dispatch = useDispatch();
  const [count, setCount] = useState(7);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);


  
  const navigate = useNavigate();

  const handlecreateform = () => {
    dispatch(openModal("addCredit"));
  };
  const handleEditClick = () => {
    dispatch(openModal("chooseRange"));
  };
  const handleArchiveClick = () => {
    navigate("/credithistory");
  };
  const totalTransferred = data.reduce(
    (sum, d) => sum + (d.transferredFromDeposit || 0),
    0
  );
  const totalUsed = data.reduce((sum, d) => sum + (d.creditUsed || 0), 0);
  const totalRefunded = data.reduce(
    (sum, d) => sum + (d.creditRefunded || 0),
    0
  );
  const totalBalance = data.reduce((sum, d) => sum + (d.creditBalance || 0), 0);
  
  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Student Name", accessor: "studentName" },
    { title: "Transferred from Deposit", accessor: "transferredFromDeposit" },
    { title: "Credit used", accessor: "creditUsed" },
    { title: "Credit Refunded", accessor: "creditRefunded" },
    { title: "Credit Balance", accessor: "creditBalance" },
  ];
  

  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        studentName: <LogoWithName name={item.studentName || "-"} />,
        transferredFromDeposit:
          item.transferredFromDeposit != null
            ? `INR ${item.transferredFromDeposit}`
            : "-",
        creditUsed: item.creditUsed != null ? `INR ${item.creditUsed}` : "-",
        creditRefunded:
          item.creditRefunded != null ? `INR ${item.creditRefunded}` : "-",
        creditBalance:
          item.creditBalance != null ? `INR ${item.creditBalance}` : "-",
      };
    });
  };
  
  

  const displayData = getColumnData(data);

  return (
    <>
      <div className={styles.mainContainer}>
        <div className={styles.container}>
          <div className={styles.createForm}>
            <button className={styles.archiveBtn} onClick={handleArchiveClick}>
              Credit History
            </button>
            <IconAndName
              icon={<MdOutlineTextSnippet />}
              title="Add Credit Bal"
              bgColor="Primary_Color"
              onClick={handlecreateform}
            />
          </div>
          {/* 🟩 Result Cards + This Month */}
          <div className={styles.rowWrapper}>
            <div className={styles.cardsWrapper}>
              <ResultAndCount
                label="Credit Issued"
                count={` ${totalTransferred}/-`}
                bgColor="rgba(from var(--Success_Color) r g b / 0.4)"
                textColor="Black_Color"
              />
              <ResultAndCount
                label="Credit Used"
                count={` ${totalUsed}/-`}
                bgColor="rgba(from var(--Primary_Color) r g b / 0.35)"
                textColor="Black_Color"
              />
              <ResultAndCount
                label="Credit Refunded"
                count={` ${totalRefunded}/-`}
                bgColor="rgba(from var(--Warning_Color) r g b / 0.3)"
                textColor="Black_Color"
              />
              <ResultAndCount
                label="Total Credit"
                count={` ${totalBalance}/-`}
                bgColor="rgba(from var(--Error_Color) r g b / 0.4)"
                textColor="Black_Color"
              />
            </div>

            <div className={styles.editWrapper} onClick={handleEditClick}>
              <FiEdit2 size={16} />
              <span>This Month</span>
            </div>
          </div>

          {/* 🔍 Search & Filters Row */}
          <div className={styles.totalstudentcard}>
            <div className={styles.studentsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search Student"
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>
              <div className={styles.filters}>
                <Dropdown
                  label="Student Status"
                  options={["Annual Day", "Freshers"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Program"
                  options={["Annual Day", "Freshers"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Group"
                  options={["Group 1", "Group 2"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Room"
                  options={["Room1", "Room2"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <IoMdTrash
                  size={26}
                  style={{
                    marginTop: "0.5rem",

                    opacity: 0.4,
                    color: "var(--Black_Color)",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    dispatch(openModal("delete"));
                  }}
                />
              </div>
            </div>

            {/* Student Data Table */}
            <div className={styles.dynamicdata}>
              <DynamicTable
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </>
  );
};

export default CreditBalance;
